import { render, staticRenderFns } from "./salesRecords.vue?vue&type=template&id=8335784e&scoped=true&"
import script from "./salesRecords.vue?vue&type=script&lang=js&"
export * from "./salesRecords.vue?vue&type=script&lang=js&"
import style0 from "./salesRecords.vue?vue&type=style&index=0&id=8335784e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8335784e",
  null
  
)

export default component.exports